import PlaylistFollower from '../../models/PlaylistFollower'

export const PLAYLIST_FOLLOWED = 'PLAYLIST_FOLLOWED'
export const PLAYLIST_UNFOLLOWED = 'PLAYLIST_UNFOLLOWED'

export function playlistFollowed (uuid) {
  return {
    type: PLAYLIST_FOLLOWED,
    uuid
  }
}

export function playlistUnfollowed (uuid) {
  return {
    type: PLAYLIST_UNFOLLOWED,
    uuid
  }
}

export function followPlaylist (playlist) {
  return dispatch => {
    return new Promise(resolve => {
      PlaylistFollower.create(playlist.uuid).then(() => {
        dispatch(playlistFollowed(playlist.uuid))
        resolve()
      })
    })
  }
}

export function unfollowPlaylist (playlist) {
  return dispatch => {
    return new Promise(resolve => {
      PlaylistFollower.destroy(playlist.uuid).then(() => {
        dispatch(playlistUnfollowed(playlist.uuid))
        resolve()
      })
    })
  }
}
